import { KeyValue } from '@angular/common';

export const originalOrderFunction = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
    return 0;
};
